if (!window.__baseformBuyNowBound) {
  window.__baseformBuyNowBound = true;

  const getProductScope = (element) =>
    element?.closest?.('[data-testid="product-information"]') ||
    element?.closest?.('.shopify-section') ||
    document;

  const getSelectedBundle = (scope) =>
    scope?.querySelector?.('baseform-bundle-selector .bf-bundle-card__input:checked');

  const syncBundlePrice = (bundleSelector) => {
    if (!(bundleSelector instanceof Element)) return;

    const selected = bundleSelector.querySelector('.bf-bundle-card__input:checked');
    if (!(selected instanceof HTMLInputElement)) return;

    const selectedCard = selected.closest('.bf-bundle-card');
    const displayPrice = selectedCard?.querySelector('.bf-bundle-card__price')?.textContent?.trim();
    if (!displayPrice) return;

    const scope = getProductScope(bundleSelector);
    scope.querySelectorAll('[data-testid="standalone-add-to-cart"] .bf-atc-price').forEach((price) => {
      if (price.textContent?.trim() !== displayPrice) {
        price.textContent = displayPrice;
      }
    });
  };

  const syncAllBundlePrices = () => {
    document.querySelectorAll('baseform-bundle-selector').forEach(syncBundlePrice);
  };

  const applySelectedBundleQuantity = (scope, form) => {
    const selected = getSelectedBundle(scope);
    if (!(selected instanceof HTMLInputElement)) return;

    const quantity = Math.max(1, Number.parseInt(selected.dataset.quantity || '1', 10));
    let quantityInput = form.querySelector('input[name="quantity"]');

    if (!(quantityInput instanceof HTMLInputElement)) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.setAttribute('data-bf-bundle-quantity', 'true');
      form.appendChild(quantityInput);
    }

    quantityInput.value = String(quantity);
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('baseform-bundle-selector .bf-bundle-card__input')) return;

    const bundleSelector = event.target.closest('baseform-bundle-selector');
    if (bundleSelector) syncBundlePrice(bundleSelector);
  });

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(syncAllBundlePrices);
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-bf-buy-now]');
    if (!(button instanceof HTMLButtonElement)) return;

    const productForm = button.closest('product-form-component');
    const form = productForm?.querySelector('form');
    if (!(form instanceof HTMLFormElement)) return;

    const scope = getProductScope(button);
    applySelectedBundleQuantity(scope, form);

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const route = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(route, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data?.status) {
        throw new Error(data?.description || data?.message || 'Unable to start checkout.');
      }

      window.location.assign('/checkout');
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.setCustomValidity(error instanceof Error ? error.message : 'Unable to start checkout.');
      button.reportValidity();
      button.setCustomValidity('');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.requestAnimationFrame(syncAllBundlePrices), { once: true });
  } else {
    window.requestAnimationFrame(syncAllBundlePrices);
  }
}
